export const EMAIL_TABLE_STYLES = {
  table:
    "border-collapse: collapse; table-layout: fixed; width: 100%; margin: 12px 0; font-family: Arial, Helvetica, sans-serif; font-size: 14px; color: #212121;",
  th: "border: 1px solid #bdbdbd; padding: 8px 12px; background-color: #f5f5f5; color: #212121; font-weight: 600; text-align: left; vertical-align: top;",
  td: "border: 1px solid #bdbdbd; padding: 8px 12px; vertical-align: top;",
  paragraph: "margin: 0;",
} as const;
